<div [class.row]="isInline()" [class.justified]="isJustified()">
  <div [class.text-end]="isInlineOnly()" [class.col-sm-2]="isInline()" *ngIf="name">
    <label [class.col-form-label]="isInline()" class="form-label fw-bold">{{ name }}</label>
  </div>
  <div [class.col-sm-10]="isInline()">
    <shared-ui-datetime-range-picker-popup
      #rangePickerPopup
      (dateFilter)="dateFilterChanged($event)"
      [formControlVariableName]="formControlVariableName"
      [formControlSearchTerm]="formControlSearchTerm"
    ></shared-ui-datetime-range-picker-popup>
  </div>
</div>
